import { useLocalStorage } from "@vueuse/core";
import { defineStore } from "pinia";
import { computed } from "vue";
import { CardColors, PencilShapeColors } from "../rich-text/colors/colors";

interface ClientSettings {
  LastPencilColor: string;
  LastPencilWidth: string;
  LastCardColor: string;
  LastSectionColor: string;
  [key: string]: string | undefined;
}

const DEFAULT_SETTINGS: ClientSettings = {
  LastPencilColor: PencilShapeColors.gray,
  LastPencilWidth: "3",
  LastCardColor: CardColors.yellow,
  LastSectionColor: "#f9fafb",
};

export const useClientSettingsStore = defineStore("clientSettings", () => {
  // use Partial to allow for missing settings that will be filled in with defaults and so that we won't store defaults in localStorage after first write
  const persistedSettings = useLocalStorage<Partial<ClientSettings>>("clientSettings", {}, { listenToStorageChanges: false, writeDefaults: false });

  function set(key: string, value: string) {
    persistedSettings.value[key] = value;
  }

  const settings = computed(() => {
    return {
      ...DEFAULT_SETTINGS,
      ...persistedSettings.value,
    };
  });

  function get(key: string) {
    const value = settings.value[key];
    return value?.toString();
  }

  return {
    settings,
    set,
    get,
  };
});

export function setClientSetting(key: string, value: string) {
  const store = useClientSettingsStore();

  store.set(key, value);
}

export function getClientSetting(key: string) {
  const store = useClientSettingsStore();

  return store.get(key);
}
